export const PROJECT_ID = "5yvv6z6b97u9";
export const APP_TYPE = "music";
export const LOGIN_API = "https://academics.newtonschool.co/api/v1/user/login";
export const SIGNUP_API = "https://academics.newtonschool.co/api/v1/user/signup";
export const OLD_SONGS_API = 'https://academics.newtonschool.co/api/v1/music/song?limit=100&sort={"release":-1}';
export const NEW_SONGS_API = 'https://academics.newtonschool.co/api/v1/music/song?limit=100&sort={"release":1}';
